import React, { useState } from "react";
import { Form, Button } from 'reactstrap';
import User from "~/services/user";


const PushNotificationButton = ()=> {

  const [disabled   , setDisabled]   = useState(false);
  const [permission , setPermission] = useState(("Notification" in window) ? Notification.permission : 'denied');

  const isIOS = [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(window.navigator?.userAgentData?.platform || window.navigator?.platform || 'unknown')
      || (window.navigator.userAgent.includes("Mac") && "ontouchend" in document);

  const showNotificationPermission = async ()=> {

    setDisabled(true);

    Notification.requestPermission().then(async (permission)=> {

      setPermission(permission);
      let sw = await navigator.serviceWorker.ready;
      let push = (await sw.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: process.env.REACT_APP_VAPID_PUBLIC_KEY
      }).catch(()=> setDisabled(false))).toJSON();

      User.registerPushSubscription({
        endpoint  : push.endpoint,
        authKey   : push.keys.auth,
        publicKey : push.keys.p256dh,
      }).finally(()=> setDisabled(false));
    });
  };

  if (isIOS) return null;

  if(permission == 'denied') return '';

  if(permission == 'granted') {
    return(
      <Form className="theme-form">
        <Button color="success" className="btn-block m-t-30 m-b-30" disabled style={{fontSize:14}}>
          Push Notification enabled on this device
        </Button>
      </Form>
    );
  }

  return (
    <Form className="theme-form">
      <Button color="primary" className="btn-block m-t-30 m-b-30" onClick={showNotificationPermission} disabled={disabled} style={{fontSize:14}}>
       { !disabled && <span> Subscribe to push notifications  </span> }
       {  disabled && <span> Allow notifications </span> }
      </Button>
    </Form>
  );
};

export default PushNotificationButton;
